import { AudioNode } from './audio';
import { CodeNode } from './code';
import { DropNode } from './drop';
import { FileNode } from './file';
import { ImageNode } from './image';
import { TextNode } from './text';
import { TweetNode } from './tweet';
import { VideoNode } from './video';
import { MagicNode } from './magic';
import { UploadNode } from './upload';
import { ToolNode } from './tool';
import { StickyNoteNode } from './sticky-note';

export const nodeTypes = {
  image: ImageNode,
  text: TextNode,
  drop: DropNode,
  video: VideoNode,
  audio: AudioNode,
  code: CodeNode,
  file: FileNode,
  tweet: TweetNode,
  magic: MagicNode,
  upload: UploadNode,
  tool: ToolNode,
  stickyNote: StickyNoteNode,
};
